import { render } from "./EditorWorksCard.vue?vue&type=template&id=1a82f6f8&scoped=true"
import script from "./EditorWorksCard.vue?vue&type=script&lang=js"
export * from "./EditorWorksCard.vue?vue&type=script&lang=js"

import "./EditorWorksCard.vue?vue&type=style&index=0&id=1a82f6f8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a82f6f8"]])

export default __exports__